import { render, staticRenderFns } from "./SubmitSrc.vue?vue&type=template&id=59cd55c9"
import script from "./SubmitSrc.vue?vue&type=script&lang=js"
export * from "./SubmitSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports